<template>
  <div class="row step-selector no-gutters">
    <div class="step-inputs col-lg-8">
      <vue-product-selector :sim="sim" :builder="builder" :viewAll="true" :callCentre="true"/>
    </div>
    <div class="col-lg-4 deal-info-content">
      <vue-deal-info :builder="builder"/>
    </div>
  </div>
</template>

<script>
import VueProductSelector from "@/components/elements/vue-product-selector";
import VueDealInfo from "@/components/elements/vue-deal-info";
import store from "@/store";
import SimModel from "@/models/sim.model";

// import { CART_UPDATE_CURRENT_ITEM } from "@/store/actions.type";

export default {
  name: "product-selector",
  components: {
    "vue-deal-info": VueDealInfo,
    "vue-product-selector": VueProductSelector
  },
  props: ["builder"],
  data() {
    return {
      sim: new SimModel(store.state.cart.current_sim)
    };
  },
  watch: {
    
  },
  mounted() {
  }
};
</script>